import { useAppStore } from '@/lib/app-store'

/**
 * `true` once client React has mounted (set in a post-mount effect in `__root`).
 *
 * Under full SSR an interactive control is in the server HTML before React attaches its handlers, so a
 * click/change in that pre-hydration window is silently dropped (the menu never opens, the upload never
 * registers). Gate such controls on this flag — e.g. `disabled={!useHydrated()}` — so they render inert
 * until React is live. That makes the dropped-event window an honest, brief disabled state for real users,
 * and lets Playwright's built-in actionability wait (it waits for an enabled element) cover hydration with
 * no bespoke "wait for hydration" test helper.
 *
 * SSR-safe: `false` on the server AND on the first client render (the effect hasn't run yet), so the markup
 * matches and there's no hydration mismatch; the effect then flips it to `true` and the control enables.
 */
export function useHydrated(): boolean {
  return useAppStore((state) => state.hydrated)
}
